import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type SubscriptionWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.subscription> & {
    // Capability-specific UDO bindings, such as dynamically created templates, belong here.
};

export const subscriptionWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({}),
}) satisfies zod.ZodType<SubscriptionWorkspaceCapabilityUdoBindings>;
